import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Search, Filter, MapPin, Clock, Users, Tag, ArrowRight, ChevronDown, Home, Globe, Briefcase, Leaf, ArrowLeft, ChevronRight } from 'lucide-react';
export function EventsPage() {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('consigliati');
  const [openEventModal, setOpenEventModal] = useState(null);
  // Mock data for registered users
  const mockUsers = {
    1: [{
      id: 1,
      name: 'Marco Bianchi',
      role: 'UX Designer',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      matchScore: 88
    }, {
      id: 2,
      name: 'Laura Rossi',
      role: 'Product Manager',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
      matchScore: 92
    }, {
      id: 3,
      name: 'Giovanni Verdi',
      role: 'Design Thinking Coach',
      avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
      matchScore: 85
    }],
    2: [{
      id: 4,
      name: 'Sofia Esposito',
      role: 'Startup Founder',
      avatar: 'https://randomuser.me/api/portraits/women/28.jpg',
      matchScore: 79
    }, {
      id: 5,
      name: 'Luca Romano',
      role: 'Business Angel',
      avatar: 'https://randomuser.me/api/portraits/men/55.jpg',
      matchScore: 81
    }, {
      id: 6,
      name: 'Chiara Marino',
      role: 'Marketing Specialist',
      avatar: 'https://randomuser.me/api/portraits/women/33.jpg',
      matchScore: 90
    }],
    3: [{
      id: 7,
      name: 'Matteo Ricci',
      role: 'Digital Strategist',
      avatar: 'https://randomuser.me/api/portraits/men/42.jpg',
      matchScore: 83
    }, {
      id: 8,
      name: 'Elena Conti',
      role: 'SEO Specialist',
      avatar: 'https://randomuser.me/api/portraits/women/66.jpg',
      matchScore: 75
    }, {
      id: 9,
      name: 'Roberto Ferrari',
      role: 'Content Creator',
      avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
      matchScore: 78
    }],
    4: [{
      id: 10,
      name: 'Alessia Moretti',
      role: 'UI Designer',
      avatar: 'https://randomuser.me/api/portraits/women/17.jpg',
      matchScore: 94
    }, {
      id: 11,
      name: 'Davide Rizzo',
      role: 'UX Researcher',
      avatar: 'https://randomuser.me/api/portraits/men/37.jpg',
      matchScore: 89
    }, {
      id: 12,
      name: 'Martina Gallo',
      role: 'Interaction Designer',
      avatar: 'https://randomuser.me/api/portraits/women/57.jpg',
      matchScore: 91
    }]
  };
  // Close modal when clicking outside
  const handleCloseModal = () => {
    setOpenEventModal(null);
  };
  const events = [{
    id: 1,
    title: 'Design Thinking Workshop',
    date: 'May 28, 2023',
    time: '14:00 - 17:00',
    location: 'Social Hub Rome',
    image: 'https://images.unsplash.com/photo-1540317580384-e5d43867caa6?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'A practical workshop to learn how to apply Design Thinking to your projects.',
    tags: ['Design', 'Innovation'],
    matchScore: 92,
    participants: 18,
    recommended: true
  }, {
    id: 2,
    title: 'Pitch Competition',
    date: 'June 5, 2023',
    time: '16:00 - 19:00',
    location: 'Social Hub Milan',
    image: 'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F1047381583%2F2586066230221%2F1%2Foriginal.20250606-130645?crop=focalpoint&fit=crop&w=940&auto=format%2Ccompress&q=75&sharp=10&fp-x=0.491477272727&fp-y=0.110894941634&s=3bcd5733f6b374a8350afadc66088d68',
    description: 'Present your startup or business idea in front of investors and mentors.',
    tags: ['Startup', 'Business'],
    matchScore: 85,
    participants: 24,
    recommended: true
  }, {
    id: 3,
    title: 'Digital Marketing Masterclass',
    date: 'June 12, 2023',
    time: '10:00 - 12:30',
    location: 'Social Hub Rome',
    image: 'https://images.unsplash.com/photo-1558403194-611308249627?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'Advanced digital marketing strategies to grow your business.',
    tags: ['Marketing', 'Digital'],
    matchScore: 78,
    participants: 32,
    recommended: true
  }, {
    id: 4,
    title: 'UX/UI Design Meetup',
    date: 'June 18, 2023',
    time: '18:00 - 20:00',
    location: 'Social Hub Florence',
    image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'Informal meeting to discuss the latest trends in interface design.',
    tags: ['UX', 'Design'],
    matchScore: 95,
    participants: 15,
    recommended: false
  }, {
    id: 5,
    title: 'Networking Breakfast',
    date: 'June 22, 2023',
    time: '08:30 - 10:00',
    location: 'Social Hub Turin',
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'Networking breakfast with professionals from the tech sector.',
    tags: ['Networking', 'Tech'],
    matchScore: 82,
    participants: 20,
    recommended: false
  }, {
    id: 6,
    title: 'Blockchain & Crypto Conference',
    date: 'June 30, 2023',
    time: '09:00 - 17:00',
    location: 'Social Hub Milan',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'A day dedicated to blockchain technologies and cryptocurrencies.',
    tags: ['Blockchain', 'Crypto'],
    matchScore: 70,
    participants: 45,
    recommended: false
  }];
  const filteredEvents = activeFilter === 'consigliati' ? events.filter(event => event.recommended) : events;
  return <div className="flex flex-col min-h-screen w-full bg-white text-black font-sans" data-id="element-997">
      {/* Main content */}
      <div className="flex-grow bg-white pt-6 pb-20 md:pb-10" data-id="element-998">
        <div className="max-w-6xl mx-auto px-0" data-id="element-999">
          {/* Breadcrumbs navigation */}
          <nav className="flex items-center text-sm mb-6" data-id="element-1000">
            <button onClick={() => navigate('/networking')} className="flex items-center text-gray-600 hover:text-black" data-id="element-1001">
              <ArrowLeft className="h-4 w-4 mr-1" data-id="element-1002" />
              <span data-id="element-1003">Networking</span>
            </button>
            <ChevronRight className="h-4 w-4 mx-2 text-gray-400" data-id="element-1004" />
            <span className="text-black font-medium" data-id="element-1005">Events</span>
          </nav>
          {/* Header */}
          <div className="mb-8" data-id="element-1006">
            <h1 className="text-2xl md:text-3xl font-light font-sharp-grotesk mb-2" data-id="element-1007">
              Events
            </h1>
            <p className="text-gray-600" data-id="element-1008">
              Discover upcoming events organized by the Social Hub. Participate
              in workshops, seminars, and meetings that match your interests and
              meet people with strong matching scores.
            </p>
          </div>
          {/* Search and filter */}
          <div className="mb-6" data-id="element-1009">
            <div className="flex flex-col md:flex-row gap-4" data-id="element-1010">
              <div className="relative flex-grow" data-id="element-1011">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1012">
                  <Search className="h-5 w-5 text-gray-400" data-id="element-1013" />
                </div>
                <input type="text" className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-black focus:border-black" placeholder="Search events..." data-id="element-1014" />
              </div>
              <div className="flex gap-3" data-id="element-1015">
                <button className="px-4 py-2 border border-gray-300 rounded-lg flex items-center gap-2 hover:bg-gray-50 transition-colors" data-id="element-1016">
                  <Filter className="h-4 w-4" data-id="element-1017" />
                  <span data-id="element-1018">Filters</span>
                </button>
                <button className="px-4 py-2 border border-gray-300 rounded-lg flex items-center gap-2 hover:bg-gray-50 transition-colors" data-id="element-1019">
                  <MapPin className="h-4 w-4" data-id="element-1020" />
                  <span data-id="element-1021">Rome</span>
                  <ChevronDown className="h-4 w-4 ml-1" data-id="element-1022" />
                </button>
              </div>
            </div>
          </div>
          {/* Event filters */}
          <div className="mb-6 border-b border-gray-200" data-id="element-1023">
            <div className="flex space-x-6" data-id="element-1024">
              <button className={`pb-3 text-sm font-medium ${activeFilter === 'consigliati' ? 'text-black border-b-2 border-black' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveFilter('consigliati')} data-id="element-1025">
                Recommended for you
              </button>
              <button className={`pb-3 text-sm font-medium ${activeFilter === 'tutti' ? 'text-black border-b-2 border-black' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveFilter('tutti')} data-id="element-1026">
                All events
              </button>
            </div>
          </div>
          {/* Events grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1027">
            {filteredEvents.map(event => <div key={event.id} className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-shadow" data-id="element-1028">
                <div className="flex justify-between items-center border-b border-gray-100 px-4 py-3" data-id="element-1029">
                  <h3 className="font-medium text-base font-sharp-grotesk" data-id="element-1030">
                    {event.title}
                  </h3>
                  <span className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded-full whitespace-nowrap flex items-center font-rubik" data-id="element-1031">
                    <span className={`inline-block w-2 h-2 rounded-full mr-2 ${event.matchScore >= 90 ? 'bg-green-500' : event.matchScore >= 80 ? 'bg-yellow-500' : 'bg-gray-500'}`} data-id="element-1032"></span>
                    Match: {event.matchScore}%
                  </span>
                </div>
                <div className="p-4" data-id="element-1033">
                  <div className="mb-4" data-id="element-1034">
                    <div className="relative h-40 mb-4 rounded-lg overflow-hidden" data-id="element-1035">
                      <img src={event.title === 'Design Thinking Workshop' ? 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80' : event.image} alt={event.title} className="w-full h-full object-cover" data-id="element-1036" />
                      {event.matchScore >= 90 && <div className="absolute top-3 right-3 bg-black text-white text-xs font-medium px-2 py-1 rounded-full flex items-center" data-id="element-1037">
                          <span data-id="element-1038">High match</span>
                          <span className="w-2 h-2 bg-green-500 rounded-full ml-1.5" data-id="element-1039"></span>
                        </div>}
                    </div>
                    <p className="text-sm text-gray-600 mb-3 font-rubik" data-id="element-1040">
                      {event.description}
                    </p>
                    <div className="flex items-center text-gray-500 text-sm mb-3" data-id="element-1041">
                      <Calendar className="w-4 h-4 mr-2" data-id="element-1042" />
                      <span data-id="element-1043">{event.date}</span>
                      <span className="mx-2" data-id="element-1044">•</span>
                      <Clock className="w-4 h-4 mr-2" data-id="element-1045" />
                      <span data-id="element-1046">{event.time}</span>
                    </div>
                    <div className="flex items-center text-gray-500 text-sm mb-4" data-id="element-1047">
                      <MapPin className="w-4 h-4 mr-2" data-id="element-1048" />
                      <span data-id="element-1049">{event.location}</span>
                    </div>
                    <div className="flex flex-wrap gap-2" data-id="element-1050">
                      {event.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full" data-id="element-1051">
                          {tag}
                        </span>)}
                    </div>
                  </div>
                </div>
                <div className="border-t border-gray-100 pt-3 px-4 pb-4" data-id="element-1052">
                  <div className="flex items-center justify-between" data-id="element-1053">
                    <button onClick={() => setOpenEventModal(event.id)} className="flex items-center text-gray-500 text-sm hover:text-black transition-colors" data-id="element-1054">
                      <Users className="w-4 h-4 mr-2" data-id="element-1055" />
                      <span data-id="element-1056">{event.participants} participants</span>
                      <ArrowRight className="w-3 h-3 ml-1" data-id="element-1057" />
                    </button>
                    <button className="text-xs font-medium text-white bg-black px-3 py-1.5 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-1058">
                      Join
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      {/* Participants Modal */}
      {openEventModal && <>
          <div className="fixed inset-0 bg-black bg-opacity-30 z-40 pointer-events-none" onClick={handleCloseModal} data-id="element-1059" />
          <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-lg z-50 animate-slide-up pointer-events-auto" data-id="element-1060">
            <div className="flex flex-col h-[80vh] max-h-[80vh]" data-id="element-1061">
              <div className="sticky top-0 bg-white z-10 px-6 pt-5 pb-4 border-b border-gray-100 flex justify-between items-center" data-id="element-1062">
                <h3 className="text-lg font-medium font-sharp-grotesk" data-id="element-1063">
                  Event Participants
                </h3>
                <button onClick={handleCloseModal} className="p-1 rounded-full hover:bg-gray-100" data-id="element-1064">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1065">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-1066" />
                  </svg>
                </button>
              </div>
              <div className="flex-1 overflow-y-auto px-6 py-4" data-id="element-1067">
                {/* Event summary */}
                <div className="bg-gray-50 rounded-lg p-4 mb-5" data-id="element-1068">
                  <div className="flex items-start" data-id="element-1069">
                    <div className="h-16 w-16 rounded-md overflow-hidden mr-3 flex-shrink-0" data-id="element-1070">
                      <img src={events.find(e => e.id === openEventModal)?.image} alt="Event" className="h-full w-full object-cover" data-id="element-1071" />
                    </div>
                    <div data-id="element-1072">
                      <h4 className="font-medium text-base mb-1" data-id="element-1073">
                        {events.find(e => e.id === openEventModal)?.title}
                      </h4>
                      <div className="flex items-center text-xs text-gray-500 mb-1" data-id="element-1074">
                        <Calendar className="w-3 h-3 mr-1" data-id="element-1075" />
                        <span data-id="element-1076">
                          {events.find(e => e.id === openEventModal)?.date}
                        </span>
                        <span className="mx-1" data-id="element-1077">•</span>
                        <Clock className="w-3 h-3 mr-1" data-id="element-1078" />
                        <span data-id="element-1079">
                          {events.find(e => e.id === openEventModal)?.time}
                        </span>
                      </div>
                      <div className="flex items-center text-xs text-gray-500" data-id="element-1080">
                        <MapPin className="w-3 h-3 mr-1" data-id="element-1081" />
                        <span data-id="element-1082">
                          {events.find(e => e.id === openEventModal)?.location}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Filter and search */}
                <div className="mb-5" data-id="element-1083">
                  <div className="flex justify-between items-center mb-3" data-id="element-1084">
                    <h4 className="font-medium text-sm" data-id="element-1085">
                      {mockUsers[openEventModal]?.length} Participants
                    </h4>
                    <div className="flex items-center space-x-2" data-id="element-1086">
                      <select className="text-xs border border-gray-200 rounded-md px-2 py-1 bg-white" data-id="element-1087">
                        <option data-id="element-1088">Sort by matching</option>
                        <option data-id="element-1089">Sort by name</option>
                        <option data-id="element-1090">Sort by role</option>
                      </select>
                    </div>
                  </div>
                  <div className="relative mb-4" data-id="element-1091">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-1092" />
                    <input type="text" placeholder="Search participants..." className="w-full pl-10 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-black" data-id="element-1093" />
                  </div>
                </div>
                <div className="mb-4" data-id="element-1094">
                  <p className="text-sm text-gray-600 mb-3" data-id="element-1095">
                    Here are the people who will attend this event. Discover
                    your potential matching with each participant.
                  </p>
                </div>
                {/* Matching categories */}
                <div className="mb-5" data-id="element-1096">
                  <h4 className="font-medium text-sm mb-3 flex items-center" data-id="element-1097">
                    <span className="w-3 h-3 bg-green-500 rounded-full mr-2" data-id="element-1098"></span>
                    High match (90%+)
                  </h4>
                  <div className="space-y-3 mb-5" data-id="element-1099">
                    {mockUsers[openEventModal]?.filter(user => user.matchScore >= 90).map(user => <div key={user.id} className="flex items-center p-3 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1100">
                          <div className="mr-3 relative" data-id="element-1101">
                            <img src={user.avatar} alt={user.name} className="w-12 h-12 rounded-full object-cover" data-id="element-1102" />
                            <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5 border border-gray-200" data-id="element-1103">
                              <div className="w-4 h-4 rounded-full bg-green-500" data-id="element-1104"></div>
                            </div>
                          </div>
                          <div className="flex-1" data-id="element-1105">
                            <h4 className="font-medium text-sm" data-id="element-1106">{user.name}</h4>
                            <p className="text-xs text-gray-500" data-id="element-1107">{user.role}</p>
                            <div className="flex mt-1 space-x-1" data-id="element-1108">
                              <span className="px-2 py-0.5 bg-gray-100 rounded-full text-xs" data-id="element-1109">
                                Design
                              </span>
                              <span className="px-2 py-0.5 bg-gray-100 rounded-full text-xs" data-id="element-1110">
                                UX
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col items-end space-y-2" data-id="element-1111">
                            <div className="flex items-center bg-gray-100 px-2 py-1 rounded-full" data-id="element-1112">
                              <span className="text-xs font-medium" data-id="element-1113">
                                Match {user.matchScore}%
                              </span>
                            </div>
                            <div className="flex space-x-2" data-id="element-1114">
                              <button className="p-1.5 rounded-full border border-gray-200 hover:bg-gray-100" data-id="element-1115">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1116">
                                  <path d="M8 12H16M12 8V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-1117" />
                                </svg>
                              </button>
                              <button className="p-1.5 rounded-full border border-gray-200 hover:bg-gray-100" data-id="element-1118">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1119">
                                  <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1120" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>)}
                  </div>
                  <h4 className="font-medium text-sm mb-3 flex items-center" data-id="element-1121">
                    <span className="w-3 h-3 bg-yellow-500 rounded-full mr-2" data-id="element-1122"></span>
                    Good match (80-89%)
                  </h4>
                  <div className="space-y-3 mb-5" data-id="element-1123">
                    {mockUsers[openEventModal]?.filter(user => user.matchScore >= 80 && user.matchScore < 90).map(user => <div key={user.id} className="flex items-center p-3 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1124">
                          <div className="mr-3 relative" data-id="element-1125">
                            <img src={user.avatar} alt={user.name} className="w-12 h-12 rounded-full object-cover" data-id="element-1126" />
                            <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5 border border-gray-200" data-id="element-1127">
                              <div className="w-4 h-4 rounded-full bg-yellow-500" data-id="element-1128"></div>
                            </div>
                          </div>
                          <div className="flex-1" data-id="element-1129">
                            <h4 className="font-medium text-sm" data-id="element-1130">{user.name}</h4>
                            <p className="text-xs text-gray-500" data-id="element-1131">{user.role}</p>
                            <div className="flex mt-1 space-x-1" data-id="element-1132">
                              <span className="px-2 py-0.5 bg-gray-100 rounded-full text-xs" data-id="element-1133">
                                Marketing
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col items-end space-y-2" data-id="element-1134">
                            <div className="flex items-center bg-gray-100 px-2 py-1 rounded-full" data-id="element-1135">
                              <span className="text-xs font-medium" data-id="element-1136">
                                Match {user.matchScore}%
                              </span>
                            </div>
                            <div className="flex space-x-2" data-id="element-1137">
                              <button className="p-1.5 rounded-full border border-gray-200 hover:bg-gray-100" data-id="element-1138">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1139">
                                  <path d="M8 12H16M12 8V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-1140" />
                                </svg>
                              </button>
                              <button className="p-1.5 rounded-full border border-gray-200 hover:bg-gray-100" data-id="element-1141">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1142">
                                  <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1143" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>)}
                  </div>
                  <h4 className="font-medium text-sm mb-3 flex items-center" data-id="element-1144">
                    <span className="w-3 h-3 bg-gray-500 rounded-full mr-2" data-id="element-1145"></span>
                    Moderate match ( 80%)
                  </h4>
                  <div className="space-y-3" data-id="element-1146">
                    {mockUsers[openEventModal]?.filter(user => user.matchScore < 80).map(user => <div key={user.id} className="flex items-center p-3 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1147">
                          <div className="mr-3 relative" data-id="element-1148">
                            <img src={user.avatar} alt={user.name} className="w-12 h-12 rounded-full object-cover" data-id="element-1149" />
                            <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5 border border-gray-200" data-id="element-1150">
                              <div className="w-4 h-4 rounded-full bg-gray-500" data-id="element-1151"></div>
                            </div>
                          </div>
                          <div className="flex-1" data-id="element-1152">
                            <h4 className="font-medium text-sm" data-id="element-1153">{user.name}</h4>
                            <p className="text-xs text-gray-500" data-id="element-1154">{user.role}</p>
                            <div className="flex mt-1 space-x-1" data-id="element-1155">
                              <span className="px-2 py-0.5 bg-gray-100 rounded-full text-xs" data-id="element-1156">
                                Finance
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col items-end space-y-2" data-id="element-1157">
                            <div className="flex items-center bg-gray-100 px-2 py-1 rounded-full" data-id="element-1158">
                              <span className="text-xs font-medium" data-id="element-1159">
                                Match {user.matchScore}%
                              </span>
                            </div>
                            <div className="flex space-x-2" data-id="element-1160">
                              <button className="p-1.5 rounded-full border border-gray-200 hover:bg-gray-100" data-id="element-1161">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1162">
                                  <path d="M8 12H16M12 8V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-1163" />
                                </svg>
                              </button>
                              <button className="p-1.5 rounded-full border border-gray-200 hover:bg-gray-100" data-id="element-1164">
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1165">
                                  <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1166" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>)}
                  </div>
                </div>
              </div>
              <div className="sticky bottom-0 bg-white border-t border-gray-100 px-6 py-4" data-id="element-1167">
                <div className="flex items-center justify-between mb-3" data-id="element-1168">
                  <h4 className="font-medium text-sm" data-id="element-1169">
                    Average matching with participants
                  </h4>
                  <div className="flex items-center bg-gray-100 px-2 py-1 rounded-full" data-id="element-1170">
                    <span className="text-xs font-medium" data-id="element-1171">
                      {Math.round(mockUsers[openEventModal]?.reduce((acc, user) => acc + user.matchScore, 0) / mockUsers[openEventModal]?.length || 0)}
                      %
                    </span>
                  </div>
                </div>
                <p className="text-xs text-gray-500 mb-4" data-id="element-1172">
                  This is your average matching level with the people who will
                  attend the event.
                </p>
                <div className="flex space-x-3" data-id="element-1173">
                  <button className="flex-1 py-3 bg-gray-100 text-gray-800 text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors" data-id="element-1174">
                    Save for later
                  </button>
                  <button className="flex-1 py-3 bg-black text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors" data-id="element-1175">
                    Join event
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>}
      {/* Mobile bottom navigation */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around py-3 z-50" data-id="element-1176">
        <button onClick={() => navigate('/')} className="flex flex-col items-center" data-id="element-1177">
          <Home className="w-5 h-5 text-gray-400" data-id="element-1178" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-1179">Home</span>
        </button>
        <button onClick={() => navigate('/connections')} className="flex flex-col items-center" data-id="element-1180">
          <Users className="w-5 h-5 text-gray-400" data-id="element-1181" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-1182">Connections</span>
        </button>
        <button onClick={() => navigate('/networking')} className="flex flex-col items-center" data-id="element-1183">
          <Globe className="w-5 h-5 text-black" data-id="element-1184" />
          <span className="text-xs mt-1 text-black" data-id="element-1185">Networking</span>
        </button>
        <button onClick={() => navigate('/collaboration')} className="flex flex-col items-center" data-id="element-1186">
          <Briefcase className="w-5 h-5 text-gray-400" data-id="element-1187" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-1188">Collaboration</span>
        </button>
        <button onClick={() => navigate('/impact')} className="flex flex-col items-center" data-id="element-1189">
          <Leaf className="w-5 h-5 text-gray-400" data-id="element-1190" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-1191">Impact</span>
        </button>
      </div>
    </div>;
}
export default {
  EventsPage
};